export default __webpack_public_path__ + "static/media/garde_corps_9.8546d2ba.png";